/**
 * CollapseButton - 展開・折りたたみを切り替える ◁▷ ボタン
 *
 * テーブル列の折りたたみやサイドバーの開閉など、
 * 折りたたみ UI に汎用的に使える atom。
 *
 * @param {boolean}  isExpanded - true のとき展開中（◁ を表示）
 * @param {function} onToggle   - クリック時のトグルハンドラ
 * @param {boolean}  fullWidth  - true のとき w-full を付与（折りたたみ中の th 内などに使用）
 */
function CollapseButton({ isExpanded, onToggle, fullWidth = false }) {
  return (
    <button
      onClick={onToggle}
      className={`text-gray-400 hover:text-gray-700 text-sm leading-none ${isExpanded ? "flex-shrink-0" : ""} ${fullWidth ? "w-full" : ""}`}
      title={isExpanded ? "この列を折りたたむ" : "この列を展開"}
    >
      {isExpanded ? "◁" : "▷"}
    </button>
  );
}

export default CollapseButton;
